// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"59946b46","453":"860ec46b","455":"8ac08578","977":"3dafad6b"}[chunkId] + ".chunk.js";
};